import script from "./DevCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./DevCourse.vue?vue&type=script&setup=true&lang=js"

import "./DevCourse.vue?vue&type=style&index=0&id=1df0a38c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df0a38c"]])

export default __exports__